/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */

/**
 * The device's lifecycle state: the state of its CURRENT enrolment, or — when it is in no enrolment — its platform inventory stage.
 */
export type DeviceState = typeof DeviceState[keyof typeof DeviceState];


export const DeviceState = {
  PRE_REGISTERED: 'PRE_REGISTERED',
  INVENTORY: 'INVENTORY',
  ARCHIVED: 'ARCHIVED',
  PROTECTED: 'PROTECTED',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  TIMED: 'TIMED',
  PARTIAL: 'PARTIAL',
  APP_RESTRICTION: 'APP_RESTRICTION',
  CALL_RESTRICTION: 'CALL_RESTRICTION',
  FULL_RESTRICTION: 'FULL_RESTRICTION',
  THEFT: 'THEFT',
  REPAIR: 'REPAIR',
  RELEASED: 'RELEASED',
} as const;
